export default {
  meta: {
    title: '商铺编辑'
  }
};
